import GlobalCases from './GlobalCases';

export default GlobalCases;
